/* B&M Machine — Mega Menu JS
   Handles: aria-expanded state, keyboard nav, click-outside.
   CSS owns all show/hide — this file only manages ARIA + focus. */

(function () {
  'use strict';

  const nav = document.querySelector('.bm-mega-nav');
  if (!nav) return;

  const ITEMS = Array.from(nav.querySelectorAll('.bm-nav__item--has-panel'));

  function getTrigger(item) {
    return item.querySelector('.bm-nav__trigger');
  }

  function getPanel(item) {
    return item.querySelector('.bm-panel');
  }

  function setExpanded(item, open) {
    const trigger = getTrigger(item);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    ITEMS.forEach(function (item) {
      if (item !== except) setExpanded(item, false);
    });
  }

  function getAllFocusable() {
    return Array.from(nav.querySelectorAll('.bm-nav__link, .bm-nav__trigger'));
  }

  function moveFocus(currentEl, delta) {
    var all = getAllFocusable();
    var idx = all.indexOf(currentEl);
    var next = all[idx + delta];
    if (next) next.focus();
  }

  ITEMS.forEach(function (item) {
    var trigger = getTrigger(item);
    var panel   = getPanel(item);

    /* sync aria-expanded with CSS :hover/:focus-within state */
    item.addEventListener('mouseenter', function () {
      closeAll(item);
      setExpanded(item, true);
    });

    item.addEventListener('mouseleave', function () {
      setExpanded(item, false);
    });

    item.addEventListener('focusin', function () {
      closeAll(item);
      setExpanded(item, true);
    });

    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) setExpanded(item, false);
    });

    /* keyboard: trigger level */
    if (trigger) {
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          setExpanded(item, true);
          var first = panel && panel.querySelector('a[href], button');
          if (first) first.focus();
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          moveFocus(trigger, 1);
        }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          moveFocus(trigger, -1);
        }
        if (e.key === 'Escape') {
          setExpanded(item, false);
          trigger.focus();
        }
      });
    }

    /* keyboard: panel level — Escape returns focus to trigger */
    if (panel) {
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.stopPropagation();
          setExpanded(item, false);
          if (trigger) trigger.focus();
        }
      });
    }
  });

  /* click outside closes all */
  document.addEventListener('click', function (e) {
    if (!nav.contains(e.target)) closeAll();
  });

  /* Escape at nav level closes all */
  nav.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();
